import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/parking-entity/';

export type CreateParkingEntityFnType = typeof createParkingEntity;

type ParkingEntity = {
    id: string;
    name: string;
    address: string;
    uic: string;
    tax_number: string;
    email: string | null;
    phone: string | null;
};

export type DTO = {
    parkingId: string;
    name: string;
    address: string;
    uic: string;
    tax_number: string;
    email?: string | null;
    phone?: string | null;
};

const createParkingEntity = ({ parkingId, ...data }: DTO): Promise<Omit<ParkingEntity, 'id'>> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseCreateParkingEntity extends MutationConfig<CreateParkingEntityFnType, GeneralSmartParkError> {}

export const useCreateParkingEntity = (options: UseCreateParkingEntity) =>
    useMutation({
        mutationFn: createParkingEntity,
        ...options,
    });

export type { ParkingEntity };
